export var DEFAULT_TTL = 600000;
//# sourceMappingURL=constants.js.map